<div class="project-card" data-testid="project-card">
  <div class="project-details-section">
    <div class="project-main-content">
      <div class="image-wrapper">
        @if ((moment(project.end_date, 'YYYY-MM-DD').isBefore(moment()) ||
          project.status === 'closed') && !project?.warranty_summary?.is_expiring) {
          <div
            class="closed"
            >closed
          </div>
        }
        <div class="image-column">
          <div class="project-image-container">
            @if (project.cover_photo?.thumb_url) {
              <img
                [src]="project.cover_photo.thumb_url"
                alt="{{ project.name }} picture"
                class="img" />
            }
            @if (!project.cover_photo?.thumb_url) {
              <div class="image-placeholder">
                <mat-icon class="placeholder-icon">apartment</mat-icon>
                <span class="placeholder-initials">{{ project.name | slice:0:2 | uppercase }}</span>
              </div>
            }
          </div>
          @if (project?.warranty_summary?.is_expiring) {
            <div class="warranty-status-section">
              <div class="warranty-status-label text-type-15">STATUS</div>
              <div class="warranty-status-badge">Warranty expiring</div>
            </div>
          }
        </div>
      </div>
      <div class="project-info-section">
        <div class="project-title-section">
          <div #projectTitle
            data-testid="project-title"
            (click)="redirectToProjectDetails(project)"
            class="project-title text-type-2"
            [matTooltip]="project.name"
            [matTooltipDisabled]="tooltipDisabled"
            matTooltipPosition="above"
            matTooltipClass="project-name-tooltip">{{ project.name }}
          </div>
          <div class="project-sub-heading text-type-10">{{ project.number }}</div>
        </div>
        <div class="contract-details">
          <div class="contract-duration">
            <app-contract-progress-card
              captionPrefix="Used: "
              captionValue="{{ project.duration_used }} days"
              captionSuffix=" / {{ project.duration }} days"
              heading="Contract duration"
              percent="{{ project.durationProgress }}"
              />
          </div>
          <div class="contract-value">
            @if (actingRole !== 'reviewer' && actingRole !== 'contractor-basic') {
              <app-contract-progress-card
                captionPrefix="Earned: "
                captionValue="{{ project.earned_value | humanReadable : 1 }}"
                captionSuffix=" / {{ project.project_value | humanReadable : 1 }}"
                heading="Contract value"
                percent="{{ project.valueProgress }}"
                />
            }
          </div>
        </div>
      </div>
    </div>
    <div class="menu-wrapper">
      <div
        [matMenuTriggerFor]="menu"
       
        class="menu-button"
        >
        <mat-icon>more_vert</mat-icon>
      </div>

      <mat-menu #menu="matMenu">
        <button
          (click)="editProject(project)"
          class="text-type-13 each-menu"
          mat-menu-item
          >
          <mat-icon class="menu-icon">{{ canEdit ? 'edit' : 'visibility' }}</mat-icon>
          <div class="menu-text">{{ canEdit ? 'Edit' : 'View details' }}</div>
        </button>
      </mat-menu>
    </div>
  </div>

  <!-- Combined RFIs & Submittals - Full Width -->
  @if (project?.summary?.rfis?.length || project?.summary?.submittals?.length) {
    <div class="combined-rfis-submittals-section">
      <app-rfis-submittals-combined
        [rfisData]="project?.summary?.rfis || []"
        [submittalsData]="project?.summary?.submittals || []"
        [projectId]="project?.id"
        />
    </div>
  }

  <!-- Grid with Issues, Recent Reports, and Offsite Tests -->
  <div class="summary-grid">
    <!-- Left Column: Issues or Open Claims (when warranty is expiring) -->
    <div class="summary-column-left">
      @if (actingRole !== 'reviewer' && actingRole !== 'contractor-basic') {
        @if (project?.warranty_summary?.is_expiring) {
          <div class="issues-summary-section">
            <app-claims-summary
              [data]="project?.warranty_summary"
              [projectId]="project?.id"
              />
          </div>
        } @else {
          <div class="issues-summary-section">
            <app-issues-summary
              [data]="project?.summary?.issues[0] || {}"
              [projectId]="project?.id"
              />
          </div>
        }
      }
    </div>

    <!-- Right Column: Recent Reports (hidden when warranty is expiring) -->
    <div class="summary-column-right">
      @if (actingRole !== 'reviewer' && actingRole !== 'contractor-basic'
        && !project?.warranty_summary?.is_expiring) {
        <div class="project-status-summary">
          <app-status-summary
            [data]="project?.summary?.daily_reports"
            [projectId]="project?.id"
            class="cursor-pointer"
            />
        </div>
      }
    </div>

    <!-- Offsite Tests (only shown if tests exist) -->
    @if (actingRole !== 'reviewer' && actingRole !== 'contractor-basic') {
      <div class="summary-column-left">
        <app-offsite-tests-summary
          [projectId]="project?.id"
          />
      </div>
    }
  </div>
</div>
